import SearchForm from './SearchForm';
import VideoThumbnail from './VideoThumbnail';
import './stylesheets/DisplayVideos.css';
import search from './backendAPI';
import React, { useState } from 'react';
import wit from './images/wit.jpg';
import bg from './images/bg.jpg';
import loader from './images/loader.gif';
import VideoPlayer from './VideoPlayer';

function DisplayVideos() {
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [nowPlaying, setNowPlaying] = useState([]);

  const handleSearch = async (searchTerm) => {
    try {
      setSearchResults([]);///------------
      setLoading(true);
      const results = await search({ searchTerm });
      setLoading(false);
      setSearchResults(results);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <>
      <SearchForm onSearch={handleSearch} />

      <div>
        <div id='Loader-Wrapper'>
          {isLoading && <img src={loader} id='Loader' alt='Loading...' />}
        </div>

        <VideoPlayer nowPlaying={nowPlaying} />

        <div className='' id='Video-Search-Results'>
          {searchResults.map((result) => (
            <VideoThumbnail
              key={result.videoUrl}
              videoUrl={result.videoUrl}
              thumbnailUrl={result.thumbnailUrl}
              title={result.title}
              description={result.description}
              platform={result.platform}
              videoId={result.videoId}
              setNowPlaying={setNowPlaying}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default DisplayVideos;

